import { HttpRequest } from "@angular/common/http";

export interface AuthJwtConfig {
	tokenGetter: (
		request?: HttpRequest<any>
	) => string | null | Promise<string | null>;
	headerName: string;
	authScheme: string | ((request?: HttpRequest<any>) => string);
	allowedDomains: Array<string | RegExp>;
	disallowedRoutes: Array<string | RegExp>;
	throwNoTokenError: boolean;
	skipWhenExpired: boolean;
	standardPorts: string[];
}

export const applyAuthJwtConfigDefaults = (config: Partial<AuthJwtConfig>): AuthJwtConfig => {
	return {
		tokenGetter: config.tokenGetter!,
		headerName: config.headerName || 'Authorization',
		authScheme: (config.authScheme && config.authScheme !== '')
			? config.authScheme
			: 'Bearer ',
		allowedDomains: config.allowedDomains || [],
		disallowedRoutes: config.disallowedRoutes || [],
		throwNoTokenError: config.throwNoTokenError || false,
		skipWhenExpired: config.skipWhenExpired || false,
		standardPorts: config.standardPorts || ['80', '443']
	}

}